import { jsx as _jsx } from "react/jsx-runtime";
import ErrorMessage from './ErrorMessage';
import { translate } from '../../../strings/i18n';
import useGetImages from '../../../hooks/useGetImages';
import { BUSINESS_ERROR_CODES } from '../../../const/status-and-error-codes';
const ChangePaymentDueDateErrors = ({ errorCode }) => {
    const { error, ladyWarning } = useGetImages();
    const defaultError = {
        image: error,
        id: 'cpdd-error-message',
        title: translate('errorMessages.troubleRetrievingInformation'),
        subTitle: translate('errorMessages.tryAgainLater')
    };
    const errorsList = [
        {
            errorListProps: {
                id: 'cpdd-period-restiction-error-message',
                image: ladyWarning,
                title: translate('errorMessages.dueDateChangePeriodRestriction.title'),
                subTitle: translate('errorMessages.dueDateChangePeriodRestriction.subTitle')
            },
            rule: errorCode === BUSINESS_ERROR_CODES.DATE_ALREADY_CHANGED
        },
        {
            errorListProps: {
                id: 'cpdd-not-eligible',
                image: ladyWarning,
                subTitle: translate('errorMessages.notEligible.body'),
                title: translate('errorMessages.notEligible.title')
            },
            rule: Boolean(errorCode) &&
                errorCode !== BUSINESS_ERROR_CODES.DATE_ALREADY_CHANGED
        }
    ];
    return (_jsx("div", { "data-cy": "message-box-container", children: _jsx(ErrorMessage, { ...(errorsList.find(({ rule }) => rule)?.errorListProps ??
                defaultError) }) }));
};
export default ChangePaymentDueDateErrors;
